//Name: Project Type
//CODE: category
const categoryOptions = [
  { id: '1', value: 'Band Position', label: "Band Position"},
  { id: '2', value: 'Band Selection', label: "Band Selection"},
  { id: '3', value: 'Candidate Assessment', label: "Candidate Assessment"},
  { id: '4', value: 'Characters', label: "Characters"},
  { id: '5', value: 'Comedy Show', label: "Comedy Show"},
  { id: '6', value: 'Choir', label: "Choir"},
  { id: '7', value: 'Corporate Video', label: "Corporate Video"},
  { id: '8', value: 'Dance Production', label: "Dance Production"},
  { id: '9', value: 'Docu-Series', label: "Docu-Series"},
  { id: '10', value: 'Documentary', label: "Documentary"},
  { id: '11', value: 'Educational', label: "Educational"},
  { id: '12', value: 'Fashion Show', label: "Fashion Show"},
  { id: '13', value: 'Feature Film', label: "Feature Film"},
  { id: '14', value: 'Look-alikes', label: "Look-alikes"},
  { id: '15', value: 'Mini Series', label: "Mini Series"},
  { id: '16', value: 'Model Contest', label: "Model Contest"},
  { id: '17', value: 'Music Video', label: "Music Video"},
  { id: '18', value: 'Musical Theatre', label: "Musical Theatre"},
  { id: '38', value: 'Orchestra', label: "Orchestra"},
  { id: '39', value: 'Opera', label: "Opera"},
  { id: '19', value: 'Pilot', label: "Pilot"},
  { id: '20', value: 'Puppet Show', label: "Puppet Show"},
  { id: '21', value: 'Runway', label: "Runway"},
  { id: '22', value: 'Short Film', label: "Short Film"},
  { id: '23', value: 'Showing', label: "Showing"},
  { id: '24', value: 'Sitcom', label: "Sitcom"},
  { id: '25', value: 'Staff Position', label: "Staff Position"},
  { id: '26', value: 'Stage Production', label: "Stage Production"},
  { id: '27', value: 'Photoshoot', label: "Photoshoot"},
  { id: '28', value: 'Promotional Event', label: "Promotional Event"},
  { id: '29', value: 'Talent Competition', label: "Talent Competition"},
  { id: '30', value: 'Talent Competition', label: "Talent Shortlist"},
  { id: '31', value: 'Talent Competition', label: "Tele-Movie"},
  { id: '32', value: 'Television Series', label: "Television Series"},
  { id: '33', value: 'Television Series', label: "Training Video"},
  { id: '34', value: 'TV Commercial', label: "TV Commercial"},
  { id: '35', value: 'Variety Performs/Acts', label: "Variety Performs/Acts"},
  { id: '36', value: 'Variety Performs/Acts', label: "Web Series"},
  { id: '37', value: 'Other', label: "Other"}
];  

export default categoryOptions;


// WEBPACK FOOTER //
// ./src/data/category.js